
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import { useRouter } from "vue-router";
import toExamine from "../modules/toExamine.vue";
import addSenField from "../modules/addSenField.vue";
import useCurrentInstance from "@/utils/useCurrentInstance";

import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  ref,
} from "vue";
import { ElMessage } from "element-plus";
import {
  findAuthSchoolListByAppId,
  batchExamineAppSchool,
} from "@/service/api";
export default defineComponent({
  components: {
    toExamine,
    addSenField,
  },
  setup() {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      authType: -1,
      keyWord: "",
      examineState: "0",
      delFactoryId: "",
      title: router.currentRoute.value.query.title,
      appId: router.currentRoute.value.query.id,
      page: 1,
      limit: 10,
      appSchoolList: [],
      total_rows: 0,
      multipleSelection: [],
      schoolId: "",
      userId: computed(() => store.state.manageUser.userId),
      name: computed(() => store.state.manageUser.name),
      authTypeList: [
        {
          id: -1,
          name: "全部类型",
        },
        {
          id: 1,
          name: "学校",
        },
        {
          id: 2,
          name: "区平台",
        },
      ],
    });
    const loading = ref(true);
    const visibleModal = ref(false);
    const fieldModal = ref(false);
    const { proxy } = useCurrentInstance();
    /**
     * 获取应用学校列表
     */
    const getSchoolList = async () => {
      loading.value = true;
      const params = {
        userId: "",
        appId: state.appId,
        type: state.authType,
        examineState: state.examineState,
        keyWord: state.keyWord,
        page: state.page,
        limit: state.limit,
      };
      const result = await findAuthSchoolListByAppId(params);
      if (result && parseInt(result.code) === 1) {
        state.appSchoolList = result.data.rows;
        state.total_rows = result.data.total_rows;
        loading.value = false;
      }
    };
    //查询表格数据
    function handleSearch() {
      state.page = 1;
      getSchoolList();
    }
    //表选择项发生变化时
    function handleSelectionChange(val: any) {
      state.multipleSelection = val;
    }

    //打开审核弹框
    function openExamineModal(index: number, id: string) {
      if (index == -1) {
        state.delFactoryId = state.multipleSelection
          .map((item: any) => item.id)
          .toString();
      } else {
        state.delFactoryId = id;
      }
      visibleModal.value = true;
    }
    //关闭弹窗
    function closeModal() {
      visibleModal.value = false;
    }
    //审核通过
    async function addSubmit(val: any) {
      const params = {
        ids: state.delFactoryId,
        examineState: val.state,
        remark: val.remark,
        examUserid: state.userId,
        examRealname: state.name,
      };
      const result = await batchExamineAppSchool(params);
      if (result && parseInt(result.code) === 1) {
        ElMessage({ message: "审核成功", type: "success" });
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
      getSchoolList();
      closeModal();
    }
    //设置敏感字段
    function addSensitiveField(appId: string,schoolId: string) {
      state.appId = appId;
      state.schoolId = schoolId;
      fieldModal.value = true;
    }
    //关闭敏感字段弹窗
    function closeFieldModall() {
      fieldModal.value = false;
    }
    function headerStyle() {
      const cellStyle =
        "background: #ffffff;color: #333333;font-weight:700;width: 100%; font-size: 12px";
      return cellStyle;
    }
    /**
     * 切换页面
     */
    function changePage(page: number) {
      state.page = page;
      getSchoolList();
    }
    /**
     * 初始加载数据
     */
    onMounted(async () => {
      if (state.appId) {
        const currentPathArr = [
          {
            title: "应用审核(新)",
            path: proxy.$routerBase + "/appList",
            name: "appList",
            isLink: true,
          },
          {
            title: state.title + "——学校授权",
            path: "",
            name: "",
          },
        ];
        proxy.changeCurrentPath(currentPathArr);
      }
      await getSchoolList();
    });
    return {
      ...toRefs(state),
      visibleModal,
      loading,
      fieldModal,
      handleSearch,
      openExamineModal,
      handleSelectionChange,
      addSubmit,
      closeModal,
      headerStyle,
      addSensitiveField,
      closeFieldModall,
      changePage
    };
  },
});
